const esgKpiPolicy = {
  EsgKpi: {
    keyFields: false as false,
  },
};

export default esgKpiPolicy;
